import PropTypes from 'prop-types';
import React, { lazy, useRef, useState } from 'react';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole, hasValue } from 'globalutils/fmUtils';
import CircularProgress from '@material-ui/core/CircularProgress';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import 'rc-tooltip/assets/bootstrap.css';
import Company from './components/Company';
import Insurance from './components/Insurance';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
const Payment = lazy(() => import(`globalcomponents/Payment/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const RenderComponent = ({
  values,
  handleEdit,
  errors,
  isNotValid,
  validateForm,
  customProps: {
    i18n,
    Styled,
    history,
    hasSaveApiStatus,
    states,
    webfleetProviders,
    cancelSubscription,
    apiStatus,
    callback,
    allCycleRules,
    allCycleExceptions,
    allVehicleTypes,
    updateCardDetails,
    eventTypes,
  },
  submitAction,
}) => {
  const apiId = 'cancelSubscription';
  const paymentRef = useRef();
  const hasCancelSubscriptionApiStatus = hasValue(apiStatus.status, 'api', apiId);
  const SERVICE_PROVIDER = window.$environment?.SERVICE_PROVIDER;

  const [open, setOpen] = useState(false);
  const [ModalListObject, setModalListObject] = useState({
    header: '',
    content: () => {
      return (
        <div className="deleteParent">
          <div className="imageSection">
            <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
          </div>
          <h2>You are going to cancel your subscription!</h2>
          <div className="deletePopupBtn">
            <div className="cancelBtn">
              <Button
                label={i18n.t('common.cancel')}
                type={'reset'}
                onClick={() => {
                  setOpen(false);
                }}
              ></Button>
            </div>
            <div className="deletebtn">
              <Button
                label={i18n.t('common.ok')}
                onClick={() => {
                  cancelSubscription({
                    apiId,
                    callback: callback,
                  });
                  setOpen(false);
                }}
              ></Button>
            </div>
          </div>
        </div>
      );
    },
  });

  const cardDetails = (data) => {
    updateCardDetails({
      apiId: 'updateCardDetails',
      data: {
        cardHolderName: data.cardHolderName,
        stripeToken: data.stripeToken,
      },
      callback: callback,
      history: history,
      i18n: i18n,
    });
    setOpen(false);
  };

  return (
    <Styled.Wrapper>
      <Company
        {...{
          values,
          handleEdit,
          errors,
          isNotValid,
          Styled,
          hasSaveApiStatus,
          states,
          webfleetProviders,
        }}
      />

      <Insurance {...{ values, handleEdit, Styled, allCycleRules, allCycleExceptions, allVehicleTypes, eventTypes }} />

      {(!hasRestrictedRole([ROLES.ADMIN]) || (!hasRestrictedRole([ROLES.ADMIN]) && !hasRestrictedRole([ROLES.MECHANIC]))) && (
        <div className="buttonSection">
          <FormStyle.ButtonsWrapper className="companyInfoSubmit">
            <Button
              id="companyInfoSubmit"
              type="submit"
              label={hasSaveApiStatus?.isLoading ? <CircularProgress color="inherit" /> : i18n.t('Save')}
              onClick={() => {
                const validateResponse = validateForm();
                validateResponse.then((data) => submitAction(data));
              }}
            />
          </FormStyle.ButtonsWrapper>

          <FormStyle.ButtonsWrapper>
            {checkServiceProvider('render_cancelSubscription', SERVICE_PROVIDER, false) ? (
              <Button
                id="subCancelButton"
                type="submit"
                label={
                  hasCancelSubscriptionApiStatus?.isLoading ? (
                    <CircularProgress color="inherit" />
                  ) : (
                    i18n.t('companyData.cancelSubscription')
                  )
                }
                onClick={() => {
                  setOpen(true);
                }}
              />
            ) : checkServiceProvider('render_button_update_card', SERVICE_PROVIDER, false) ? (
              <Button
                id="subCancelButton"
                type="submit"
                label={i18n.t('companyData.updateCreditCardDetails')}
                onClick={() => {
                  setModalListObject({
                    content: () => {
                      return (
                        <>
                          <Payment
                            getEmail
                            ref={paymentRef}
                            buttonLabel={'Update Credit Card Details'}
                            validationMessage={i18n.t('common.fieldRequiredMessage')}
                            updateCard={(data) => cardDetails(data)}
                            handleOnChange={(event, type) => {}}
                            validationMessageMail={i18n.t('common.emailValidationMessage')}
                            hidepaymentButton
                          />
                          <div className="deletebtn companyDataCard">
                            <Button
                              label={i18n.t('companyData.updateCreditCardDetails')}
                              onClick={() => {
                                paymentRef.current.handleSubmit(() => {});
                              }}
                            ></Button>
                          </div>
                        </>
                      );
                    },
                  });
                  setOpen(true);
                }}
              />
            ) : null}
          </FormStyle.ButtonsWrapper>
        </div>
      )}

      <Modal.default open={open} setOpen={setOpen} data={ModalListObject} withCloseIcon alignItemsLeft companyData />
    </Styled.Wrapper>
  );
};

export default RenderComponent;

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object.isRequired,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};
